import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { ThemeService } from "../theme/theme-service.service";

@Component({
  selector: "app-admin-dashboard",
  templateUrl: "./admin-dashboard.component.html",
  styleUrls: ["./admin-dashboard.component.scss"],
})
export class AdminDashboardComponent implements OnInit {
  sectionTitle = "Admin Dashboard";
  constructor(
    private router: Router,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService
  ) {}

  ngOnInit() {}

  showTab(pageName: string) {
    let i: number;
    let tabcontent: any;
    tabcontent = document.getElementsByClassName("info-content");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    document.getElementById(pageName).style.display = "block";
  }
}
